/**
 * Some browsers allow us to inspect the effective connection type. It
 * will return slow-2g, 2g, 3g or 4g. Everything below 4g is relatively
 * slow to stream for example large videos.
 *
 * @return {Boolean}
 */
export default () => {
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  return connection && ['slow-2g', '2g', '3g'].indexOf(connection.effectiveType) >= 0;
};
